// utils/units/index.js
//
// The measurement module: registry + conversion + parsing + normalisation +
// formatting. Every file in this folder is dependency-free and vendored
// verbatim into keepr-web; see registry.js for the rule and
// docs/plans/measurements.md for the contract.

'use strict';

const registry = require('./registry');
const convert = require('./convert');
const parse = require('./parse');
const normalize = require('./normalize');
const format = require('./format');

module.exports = {
	// Registry.
	MEASURES: registry.MEASURES,
	MEASURE_LIST: registry.MEASURE_LIST,
	UNITS: registry.UNITS,
	ALIASES: registry.ALIASES,
	RATE_TIMES: registry.RATE_TIMES,
	getMeasure: registry.getMeasure,
	getUnit: registry.getUnit,
	unitsOf: registry.unitsOf,
	isUnitOf: registry.isUnitOf,
	isComposite: registry.isComposite,
	resolveUnit: registry.resolveUnit,
	isMeasurementValue: registry.isMeasurementValue,
	// Several measures on one element (KPR-1085).
	MAX_MEASURES: registry.MAX_MEASURES,
	allowedMeasures: registry.allowedMeasures,
	isMultiMeasure: registry.isMultiMeasure,
	measureOfUnit: registry.measureOfUnit,
	unitIdsOf: registry.unitIdsOf,
	scopeOptions: registry.scopeOptions,
	// An element's own units (KPR-1109).
	OWN_PREFIX: registry.OWN_PREFIX,
	MAX_OWN_UNITS: registry.MAX_OWN_UNITS,
	MAX_OWN_NAME: registry.MAX_OWN_NAME,
	isOwnUnitId: registry.isOwnUnitId,
	ownUnitsOf: registry.ownUnitsOf,
	ownUnitOf: registry.ownUnitOf,
	resolveOwnUnit: registry.resolveOwnUnit,
	ownUnitAsUnit: registry.ownUnitAsUnit,
	unitIn: registry.unitIn,
	pluralOf: registry.pluralOf,
	ownUnitIdFor: registry.ownUnitIdFor,
	ownUnitIdIn: registry.ownUnitIdIn,
	ownNameKey: registry.ownNameKey,
	sameOwnUnit: registry.sameOwnUnit,
	ownUnitNameProblem: registry.ownUnitNameProblem,
	settleOwnUnits: registry.settleOwnUnits,
	sortGroupOf: registry.sortGroupOf,

	// Conversion.
	toBase: convert.toBase,
	fromBase: convert.fromBase,
	canConvert: convert.canConvert,
	isDecreasing: convert.isDecreasing,
	baseOperator: convert.baseOperator,
	convert: convert.convert,
	splitComposite: convert.splitComposite,
	joinComposite: convert.joinComposite,

	// Parsing.
	parseMeasurement: parse.parseMeasurement,
	parseMeasurementDetailed: parse.parseMeasurementDetailed,

	// Normalisation.
	normalizeMeasurement: normalize.normalizeMeasurement,
	readMeasurement: normalize.readMeasurement,

	// Formatting.
	MAX_PRECISION: format.MAX_PRECISION,
	roundHalfAway: format.roundHalfAway,
	formatNumber: format.formatNumber,
	formatInUnit: format.formatInUnit,
	chooseDisplayUnit: format.chooseDisplayUnit,
	formatMeasurement: format.formatMeasurement,
};
